// extracted by mini-css-extract-plugin
export default {"default":"_5oYUnRx1VsXqbpun4AHe9r button","success":"_3vZJHyDTWdswnoculoDBsV button success","primary":"_5h1vQJlmxJxquwKpryFZPY button primary","danger":"_6dRx7MnN17Gz6Tt8B52ON9"};